module.exports = __webpack_public_path__ + "img/mastercard.602c9325.png";